// extracted by mini-css-extract-plugin
export default {"wave":"wave_wave__5pYqI","wave-animation":"wave_wave-animation__j4wiB"};